
function Home() {
   return (
      <div align='center' style={{margin:'0 auto', padding:20}}>
         {/*Home*/}
      </div>
   )
}
export default Home
